import { Upload, type UploadProps } from 'antd';
import {
  validateFile,
  type FileValidationError,
  type FileValidator,
} from './file-validators';

export function createBeforeUpload(options: {
  validator: FileValidator;
  onError: (error: FileValidationError) => void;
}) {
  const beforeUpload = async (file: File) => {
    const error = await validateFile(file, options.validator);
    if (error) {
      options.onError(error);
      return Upload.LIST_IGNORE;
    }
    return true as const;
  };
  return beforeUpload satisfies NonNullable<UploadProps['beforeUpload']>;
}
